/**
 * Reducer for managing selection state
 * Consolidates selection-related state: selectedShipmentIds, lastSelectedContext, selectedShipment
 */

export const SELECTION_ACTIONS = {
  SET_SELECTED_SHIPMENT_IDS: "SET_SELECTED_SHIPMENT_IDS",
  SET_LAST_SELECTED_CONTEXT: "SET_LAST_SELECTED_CONTEXT",
  SET_SELECTED_SHIPMENT: "SET_SELECTED_SHIPMENT",
  CLEAR_SELECTION: "CLEAR_SELECTION",
};

export const selectionReducer = (state, action) => {
  switch (action.type) {
    case SELECTION_ACTIONS.SET_SELECTED_SHIPMENT_IDS:
      return {
        ...state,
        selectedShipmentIds: typeof action.payload === "function"
          ? action.payload(state.selectedShipmentIds)
          : action.payload,
      };

    case SELECTION_ACTIONS.SET_LAST_SELECTED_CONTEXT:
      return {
        ...state,
        lastSelectedContext: action.payload,
      };

    case SELECTION_ACTIONS.SET_SELECTED_SHIPMENT:
      return {
        ...state,
        selectedShipment: action.payload,
      };

    case SELECTION_ACTIONS.CLEAR_SELECTION:
      return {
        ...state,
        selectedShipmentIds: [],
        lastSelectedContext: null,
      };

    default:
      return state;
  }
};

export const createSelectionActions = (dispatch) => {
  // Use stable function references to prevent unnecessary re-renders
  const setSelectedShipmentIds = (ids) =>
    dispatch({
      type: SELECTION_ACTIONS.SET_SELECTED_SHIPMENT_IDS,
      payload: ids,
    });
  const setLastSelectedContext = (context) =>
    dispatch({
      type: SELECTION_ACTIONS.SET_LAST_SELECTED_CONTEXT,
      payload: context,
    });
  const setSelectedShipment = (shipment) =>
    dispatch({
      type: SELECTION_ACTIONS.SET_SELECTED_SHIPMENT,
      payload: shipment,
    });
  const clearSelection = () =>
    dispatch({ type: SELECTION_ACTIONS.CLEAR_SELECTION });

  return {
    setSelectedShipmentIds,
    setLastSelectedContext,
    setSelectedShipment,
    clearSelection,
  };
};

